<template>
    <div>
        <h4>{{ $t('monitoring.tabs_label__monthly_report') }}</h4>
        <div class="col-lg-4">
            <!-- Start & End date -->
            <div class="row">
                <!-- Starting date -->
                <div class="col-lg-6">
                    <base-input
                        name="report.start_date"
                        v-model="MonitoringForm.report.start_date"
                        :error="getError('report.start_date')"
                        v-validate="'required'"
                        :disabled="!MonitoringForm.isEditable"
                        :data-vv-as="$t('medium_grant.technical__1_startdate')"
                        :placeholder="$t('medium_grant.technical__1_startdate')"
                        >
                        <label>{{$t('medium_grant.technical__1_startdate')}}</label>
                        <el-date-picker
                            type="date"
                            v-model="startDate"
                            :disabled="!MonitoringForm.isEditable"
                            :placeholder="$t('medium_grant.technical__1_startdate')"
                            >
                        </el-date-picker>
                    </base-input>
                </div>

                <!-- Ending date -->
                <div class="col-lg-6">
                    <base-input
                        name="report.end_date"
                        v-model="MonitoringForm.report.end_date"
                        :placeholder="$t('medium_grant.technical__1_enddate')"
                        :error="getError('report.end_date')"
                        v-validate="'required'"
                        :disabled="!MonitoringForm.isEditable"
                        :data-vv-as="$t('medium_grant.technical__1_enddate')"
                        >
                        <label>{{$t('medium_grant.technical__1_enddate')}}</label>
                        <el-date-picker
                            type="date"
                            v-model="endDate"
                            :disabled="!MonitoringForm.isEditable"
                            :placeholder="$t('medium_grant.technical__1_enddate')"
                            >
                        </el-date-picker>
                    </base-input>
                </div>
            </div>
        </div>

        <card class="mt-3" v-for="(activity_field, index) in MonitoringForm.report.field_activities" :key="'activity_field_' + index">
            <div class="row">
                <div class="col-lg-4">
                    <!-- Field Activity -->
                    <div class="form-group">
                        <label>{{ $t('monitoring.field_title__field_activity') }}</label>
                        <textarea
                            class="form-control"
                            name="monthly.field_activity_title"
                            v-model="activity_field.title"
                            v-validate="'required'"
                            :disabled="!MonitoringForm.isEditable"
                            :placeholder="'Insert Title'"
                            >
                        </textarea>
                    </div>

                    <!-- Start & End date -->
                    <div class="row">
                        <!-- Starting date -->
                        <div class="col-lg-6">
                            <base-input
                                name="report.start_date"
                                v-model="activity_field.start_date"
                                :error="getError('report.start_date')"
                                v-validate="'required'"
                                :disabled="!MonitoringForm.isEditable"
                                :data-vv-as="$t('medium_grant.technical__1_startdate')"
                                :placeholder="$t('medium_grant.technical__1_startdate')"
                                >
                                <label>{{$t('medium_grant.technical__1_startdate')}}</label>
                                <el-date-picker
                                    type="date"
                                    v-model="activity_field.start_date"
                                    :disabled="!MonitoringForm.isEditable"
                                    :placeholder="$t('medium_grant.technical__1_startdate')"
                                    >
                                </el-date-picker>
                            </base-input>
                        </div>

                        <!-- Ending date -->
                        <div class="col-lg-6">
                            <base-input
                                name="report.end_date"
                                v-model="activity_field.end_date"
                                :placeholder="$t('medium_grant.technical__1_enddate')"
                                :error="getError('report.end_date')"
                                v-validate="'required'"
                                :disabled="!MonitoringForm.isEditable"
                                :data-vv-as="$t('medium_grant.technical__1_enddate')"
                                >
                                <label>{{$t('medium_grant.technical__1_enddate')}}</label>
                                <el-date-picker
                                    type="date"
                                    v-model="activity_field.end_date"
                                    :disabled="!MonitoringForm.isEditable"
                                    :placeholder="$t('medium_grant.technical__1_enddate')"
                                    >
                                </el-date-picker>
                            </base-input>
                        </div>
                    </div>

                    <!-- Field Status -->
                    <div class="form-group">
                        <label>{{ $t('monitoring.field_title__status') }}</label>
                        <select
                            class="form-control"
                            name="monthly.status"
                            v-model="activity_field.status"
                            v-validate="'required'"
                            :disabled="!MonitoringForm.isEditable"
                            >
                            <option selected disabled value="">{{ $t('monitoring.placeholder__status') }}</option>
                            <option v-for="(status) in statuses" :key="status" :value="status">{{ status }}</option>
                        </select>
                    </div>
                    <div class="form-group" style="overflow: hidden">
                        <label>{{ $t('monitoring.field_title__comments') }}</label>
                        <comment-box
                            :is-editable="MonitoringForm.isEditable"
                            v-model="activity_field.activity_comments"
                            :comments="activity_field.activity_comments"
                            >
                        </comment-box>
                    </div>

                    <!-- Date -->
                    <!-- <base-input
                        name="monthly.field_activity_date"
                        v-model="activity_field.date"
                        v-validate="'required'"
                        :placeholder="'Date'"
                        :error="getError('grant_agreement.end_date')"
                        :data-vv-as="'Date'"
                        >
                        <label>Date</label>
                        <el-date-picker
                            type="date"
                            v-model="activity_field.date"
                            :placeholder="'Date'"
                            >
                        </el-date-picker>
                    </base-input> -->

                    <!-- Field Event/Meeting -->
                    <div class="form-group">
                        <label>{{ $t('monitoring.field_title__event_meeting') }}</label>
                        <textarea
                            class="form-control"
                            name="monthly.field_activity_event_title"
                            v-model="activity_field.event_title"
                            v-validate="'required'"
                            :disabled="!MonitoringForm.isEditable"
                            :placeholder="'Insert Title'"
                            >
                        </textarea>
                    </div>

                    <!-- Start & End date -->
                    <div class="row">
                        <!-- Starting date -->
                        <div class="col-lg-6">
                            <base-input
                                name="report.start_date"
                                v-model="activity_field.event_start_date"
                                :error="getError('report.start_date')"
                                v-validate="'required'"
                                :disabled="!MonitoringForm.isEditable"
                                :data-vv-as="$t('medium_grant.technical__1_startdate')"
                                :placeholder="$t('medium_grant.technical__1_startdate')"
                                >
                                <label>{{$t('medium_grant.technical__1_startdate')}}</label>
                                <el-date-picker
                                    type="date"
                                    v-model="activity_field.event_start_date"
                                    :disabled="!MonitoringForm.isEditable"
                                    :placeholder="$t('medium_grant.technical__1_startdate')"
                                    >
                                </el-date-picker>
                            </base-input>
                        </div>

                        <!-- Ending date -->
                        <div class="col-lg-6">
                            <base-input
                                name="report.end_date"
                                v-model="activity_field.event_end_date"
                                :placeholder="$t('medium_grant.technical__1_enddate')"
                                :error="getError('report.end_date')"
                                :disabled="!MonitoringForm.isEditable"
                                v-validate="'required'"
                                :data-vv-as="$t('medium_grant.technical__1_enddate')"
                                >
                                <label>{{$t('medium_grant.technical__1_enddate')}}</label>
                                <el-date-picker
                                    type="date"
                                    v-model="activity_field.event_end_date"
                                    :disabled="!MonitoringForm.isEditable"
                                    :placeholder="$t('medium_grant.technical__1_enddate')"
                                    >
                                </el-date-picker>
                            </base-input>
                        </div>
                    </div>

                    <!-- Event Description -->
                    <div class="form-group">
                        <label>{{ $t('monitoring.field_title__event_description') }}</label>
                        <textarea
                            class="form-control"
                            name="monthly.field_activity_event_description"
                            v-model="activity_field.event_description"
                            v-validate="'required'"
                            :disabled="!MonitoringForm.isEditable"
                            :placeholder="'Insert'"
                            >
                        </textarea>
                    </div>

                    <!-- <div v-for="(act_res, index) in activity_field.activities_results" :key="'act_res_' + index">
                        <div class="form-group">
                            <label>Results</label>
                            <textarea
                                class="form-control"
                                name="monthly.field_activity_event_description"
                                v-model="activity_field.event_description"
                                v-validate="'required'"
                                :disabled="!MonitoringForm.isEditable"
                                :placeholder="'Insert'"
                                >
                            </textarea>
                        </div>

                        <div class="form-group">
                            <label>Activities</label>
                            <textarea
                                class="form-control"
                                name="monthly.field_activity_event_description"
                                v-model="activity_field.event_description"
                                v-validate="'required'"
                                :disabled="!MonitoringForm.isEditable"
                                :placeholder="'Insert'"
                                >
                            </textarea>
                        </div>
                    </div> -->

                    <!-- Upload Meeting report/minutes -->
                    <div class="form-group file-group">
                        <span class="file-caption">{{ $t('monitoring.field_title__upload_meeting_report_minutes') }}</span>
                        <upload-file
                            v-if="MonitoringForm.initialized"
                            v-model="MonitoringForm.files.monthly['meeting_report_' + index]"
                            class="upload-file"
                            :section="'monthly.meeting_report_' + index"
                            :file-data="MonitoringForm.files.monthly['meeting_report_' + index]"
                            :is-editable="MonitoringForm.isEditable"
                            :model-name="'MonitoringReport'"
                            :size-limit="MonitoringForm.fileSizeLimit"
                        >
                        </upload-file>
                    </div>

                    <!-- Links to articles online, new info on website, info on website -->
                    <div class="form-group">
                        <label>{{ $t('monitoring.field_title__links_to_articles_online') }}</label>
                        <textarea
                            class="form-control"
                            name="monthly.field_activity_meeting_report"
                            v-model="activity_field.activities"
                            v-validate="'required'"
                            :disabled="!MonitoringForm.isEditable"
                            :placeholder="$t('monitoring.field_title__links_to_articles_online')"
                            >
                        </textarea>
                    </div>

                    <!-- Field Status -->
                    <div class="form-group">
                        <label>{{ $t('monitoring.field_title__status') }}</label>
                        <select
                            class="form-control"
                            name="monthly.event_and_meeting_status"
                            v-model="activity_field.event_and_meeting_status"
                            v-validate="'required'"
                            :disabled="!MonitoringForm.isEditable"
                            >
                            <option selected disabled value="">{{ $t('monitoring.placeholder__status') }}</option>
                            <option v-for="(status) in statuses" :key="status" :value="status">{{ status }}</option>
                        </select>
                    </div>
                    <div class="form-group" style="overflow: hidden">
                        <label>{{ $t('monitoring.field_title__comments') }}</label>
                        <comment-box
                            :is-editable="MonitoringForm.isEditable"
                            v-model="activity_field.event_and_meeting_comments"
                            :comments="activity_field.event_and_meeting_comments"
                            >
                        </comment-box>
                    </div>

                </div>

                <div class="col-lg-4">
                    <div class="form-group" style="position: relative" v-for="(document_name, document_index) in activity_field.monthly_documents" :key="'document_' + document_index">
                        <span class="msd-remove-item tim-icons icon-trash-simple" @click="removeDocument(activity_field, document_index, document_name)" v-if="MonitoringForm.isEditable"></span>
                        <upload-file
                            v-if="MonitoringForm.initialized"
                            v-model="MonitoringForm.files.monthly[document_name]"
                            class="upload-report-box"
                            :section="'monthly.' + document_name"
                            :file-data="MonitoringForm.files.monthly[document_name]"
                            :is-editable="MonitoringForm.isEditable"
                            :model-name="'MonitoringReport'"
                            :size-limit="MonitoringForm.fileSizeLimit"
                            >
                            <div class="row">
                                <div class="col-lg-12 upload-report-inner-box">
                                    <h4>{{ $t('monitoring.button_title__upload_document_here') }}</h4>
                                </div>
                            </div>
                        </upload-file>
                    </div>
                    <base-button
                        v-if="MonitoringForm.isEditable"
                        type="primary"
                        class="add-new-field-activity"
                        @click="addNewDocument(activity_field, index)"
                        >
                        {{ $t('monitoring.button_title__add_new_document') }}
                    </base-button>
                </div>

            </div>
        </card>
        <base-button
            v-if="MonitoringForm.isEditable"
            type="primary"
            class="add-new-field-activity"
            @click="addFieldActivity"
            >
            {{ $t('monitoring.button_title__add_another_field_activity') }}
            <span>{{ $t('monitoring.button_subtitle__add_another_field_activity') }}</span>
        </base-button>

    </div>
</template>
<script>
    import {MonitoringService, UserRoles, FileUploadService, MonitoringForm} from '@/services';
    import {EventBus} from '@/event-bus.js';
    import {DatePicker} from 'element-ui';
    import Multiselect from 'vue-multiselect';
    import {CommentBox} from 'src/components';

    export default
    {
        components:
        {
            MonitoringForm,
            [DatePicker.name]: DatePicker,
            Multiselect,
            CommentBox,
        },
        data()
        {
            return {
                MonitoringForm,
                reportId: parseInt(this.$route.params.reportId) || null,
                moment: '',
                startDate: '',
                endDate: '',
                statuses: [
                    'Achieved',
                    'Still ongoing',
                    'Delayed',
                    'Canceled',
                ],
            }
        },
        async beforeMount()
        {
            const vm = this;

            vm.moment = require('moment');

            if (!MonitoringForm.report.field_activities)
            {
                MonitoringForm.report.field_activities = [{}];
            }

            MonitoringForm.report.field_activities.forEach((item, index) =>
            {
                if (!item.monthly_documents)
                {
                    item.monthly_documents = Object.keys(MonitoringForm.files.monthly)
                        .filter(key => key.startsWith('activity_document_' + index + '_')).map(key => key);
                }
            });

            vm.startDate = MonitoringForm.report.start_date || '';
            vm.endDate = MonitoringForm.report.end_date || '';
        },
        methods:
        {
            addFieldActivity()
            {
                MonitoringForm.report.field_activities.push({forceObject: true});

                this.$forceUpdate();
            },

            addNewDocument(activity_field, index)
            {
                if (!activity_field.monthly_documents)
                {
                    activity_field.monthly_documents = [];
                }

                const document_index = activity_field.monthly_documents.length;

                activity_field.monthly_documents.push('activity_document_' + index + '_' + document_index);

                this.$forceUpdate();
            },

            removeDocument(activity_field, index, document_name)
            {
                if (confirm(this.$t('monitoring.confirm__remove_document')))
                {
                    activity_field.monthly_documents.splice(index, 1);

                    const file = MonitoringForm.files.monthly[document_name];

                    if (!(file instanceof File) && file.id)
                    {
                        FileUploadService.deleteMonitoringFile(file.id)
                        MonitoringForm.files.monthly[document_name] = {}
                    }
                }

                this.$forceUpdate();
            },

            getError(field)
            {
                return this.errors.first(field);
            },

            validate()
            {
                return this.$validator.validateAll().then(res =>
                {
                    this.$emit('on-validated', res, this.model);

                    return res;
                });
            },
        },
        watch:
        {
            startDate(new_val)
            {
                const date = this.moment(new_val).format('YYYY-MM-DD');

                MonitoringForm.report.start_date = (date === 'Invalid date' ? null : date);
            },
            endDate(new_val)
            {
                const date = this.moment(new_val).format('YYYY-MM-DD');

                MonitoringForm.report.end_date = (date === 'Invalid date' ? null : date);
            }
        }
    };
</script>
